import React from "react";

import { ReactComponent as AboutLoungeIcon } from "../../../assets/svg/about_lounge.svg";
import thumbManager from "../../../assets/images/Manual/thumb_manager.jpg";
import thumbCore from "../../../assets/images/Manual/thumb_core.jpg";
import thumbGearLounge from "../../../assets/images/Manual/thumb_gear-lounge.jpg";
import styles from "../Select.module.scss";

const MANUAL = [
  {
    thumb: thumbGearLounge,
    link: "https://www.enageed.jp/hubfs/servicemanual/manual_gear-lounge.pdf",
    label: "GEAR/LOUNGEサポートマニュアル",
  },
  {
    thumb: thumbCore,
    link: "https://www.enageed.jp/hubfs/servicemanual/manual_core.pdf",
    label: "COREサポートマニュアル",
  },
  {
    thumb: thumbManager,
    link: "https://www.enageed.jp/hubfs/servicemanual/manual_manager.pdf",
    label: "学校管理画面サポートマニュアル",
  },
];

const Manual = () => {
  return (
    <div className={styles.body}>
      <div className={styles.wrapper}>
        <div className={styles.container}>
          <div className={styles.inner}>
            <p className={styles.title}>
              <AboutLoungeIcon width="25" height="18" />
              マニュアルを選んでください
            </p>
            <div className={styles.manual}>
              {MANUAL.map((manual, index) => (
                <div key={index} className={styles.link}>
                  <img
                    className={styles.thumb}
                    src={manual.thumb}
                    alt={manual.label}
                  />
                  <a
                    className={styles.button}
                    href={manual.link}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    内容を確認する
                  </a>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Manual;
